<template>
  <div class="form__bporgress-container">
    <img
      class="bbee"
      src="../assets/images/11/bee_counter.png"
      alt="Pszczółka"
    />
    <img
      class="bbutterfly"
      src="../assets/images/11/motyl_1_1.png"
      alt="Motyl"
    />
    <img
      class="bumblebee"
      src="../assets/images/11/trzmiel.svg"
      alt="Trzmiel"
    />
 
    <div
      class="form__introtext"
      v-html="content.data.form_invitation.header_0"
    ></div>
    <div class="form__introcounter">
      {{ countdown }}
    </div>
    <div class="bprogress-bar">
      <!-- Bind the progress dynamically -->
      <div class="bprogress-bar-inner" :style="{ width: percent + '%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: { counterData: Number },
  inject: ["content"],
  data() {
    return {
      value: 0,
      max: 15000,
      showProgresBar: false,
      percent: 0,
      countdown: "",
    };
  },
  created() {
    this.delayedShow();
  },
  methods: {
    delayedShow() {
      let delay = 2000;
      setTimeout(() => {
        this.showProgresBar = false;
      }, delay);
      setTimeout(() => {
        this.value = this.counterData;
      }, 2000);
      setTimeout(() => {
        this.countPosition();
        this.countCountdown();
      }, 2000);
    },
    countPosition: function () {
      const percent = (this.counterData / this.max) * 100;
      if (percent > 100) {
        this.percent = 100;
      } else {
        this.percent = percent;
      }

      // console.log(this.counterData / this.max)
    },
    countCountdown: function () {
      if (this.value < this.max) {
        this.countdown = (this.max - this.value)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      } else {
        this.countdown = "0";
      }
    },
  },
};
</script>
<style scss scoped>
.bprogress-bar {
  width: 100%;
  height: 14px;
  background-color: #f0f0f0;
  border-radius: 5px;
  margin-bottom: 10px;
}
.bprogress-bar-inner {
  height: 100%;
  line-height: 30px;
  background-color: #2b2e31;
  text-align: center;
  border-radius: 4px 8px 8px 4px;
  color: white;
}
</style>
